<template>
  <div class="login-message form">
    <div class="ipt-item">
      <customField
        v-model="form.phone"
        :placeholder="$t('login.phone_placeholder')"
      >
        <template slot="prev">
          <div class="country-code" @click="showZoneCodePicker = true">
            <span>+{{ form.zone_code }}</span>
          </div>
        </template>
        <template slot="next" v-if="form.phone && form.phone.length > 0">
          <div class="icon-box" @click="clearPhone"><Icon name="clear" color="#888" /></div>
        </template>
      </customField>
    </div>
    <div class="ipt-item">
      <custom-field
        :placeholder="$t('login.message_code_placeholder')"
        v-model="form.code"
      >
        <template slot="next">
          <button
            :class="[
              'verCode-btn',
              isSendVerCode ? 'verCode-btn--disabled' : 'verCode-btn--normal'
            ]"
            :disabled="isSendVerCode"
            @click="handleSendVerCode"
            >
            {{
              isSendVerCode
                ? `(${verCodeTime}s)`
                : $t("login.send_message_btn_text")
            }}
          </button>
        </template>
      </custom-field>
    </div>

    <div class="btn-submit" :class="{dis: submitDis}" @click="login">{{ $t("common.confirm") }}</div>

    <Popup v-model="showZoneCodePicker" position="bottom">
      <Picker
        show-toolbar
        :columns="zoneCodeList"
        @confirm="handleConfirmZoneCode"
        @cancel="showZoneCodePicker = false"
      />
    </Popup>
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import { Popup, Picker, Toast, Icon } from "vant";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import { trimPlus } from "@/utils/utils.new";
import * as Sentry from "@sentry/vue";

export default {
  components: {
    customField,
    Popup,
    Picker,
    Icon
  },
  props: {
    userInfo: {
      type: [Object, String],
      defaults: function(){
        return {}
      }
    }
  },
  watch: {
    userInfo: {
      handler(newVal){
        if(newVal.phone && newVal.zone_code){
          this.form.phone = newVal.phone;
          this.form.zone_code = newVal.zone_code;
        }
      },
      immediate: true
    }
  },
  computed: {
    submitDis(){
      return !(
        trimPlus(this.form.phone) &&
        trimPlus(this.form.code)
      );
    }
  },
  data() {
    return {
      form: {
        phone: "",
        code: "",
        zone_code: 852,
        login_type: 2,
        source: "maH5"
      },
      zoneCodeList: [
        {
          text: this.$t('mki18n.t00005'),
          value: "852"
        },
        {
          text: this.$t('mki18n.t00006'),
          value: "86"
        }
      ],
      showZoneCodePicker: false,
      isSendVerCode: false,
      verCodeTime: 120,
    };
  },
  methods: {
    // 手机号清除
    clearPhone(){
      this.form.phone = "";
    },
    // 手机号验证 根据地区
    verifyPhone() {
      const { zone_code, phone } = this.form;
      if(zone_code == "86"){
        return isChinaPhone(phone);
      }
      else if(zone_code == "852"){
        return isHKPhone(phone);
      }
    },
    // 点击获取验证码
    handleSendVerCode() {
      if (!this.verifyPhone()){
        return this.$toast.fail("请输入正确的手机号");
      };
      const { phone, zone_code } = this.form;
      const params = {
        phone,
        zone_code,
        type: 1, //1登录，2注册，3找回密码
        source: "maH5"
      };
      this.$apis
        .sendVerCode(params)
        .then(res => {
          Toast(this.$t("common.message_send_success_text"));
          const { code } = res;
          this.form.code = code;
          this.isSendVerCode = true;
          this.setIntervalSendCode();
        })
        .catch(e => {

        });
    },
    setIntervalSendCode() {
      const now = new Date().getTime();
      const end = new Date(now + this.verCodeTime * 1000).getTime();
      this.verCodeTimer = setInterval(() => {
        this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
        if (this.verCodeTime <= 0) {
          clearInterval(this.verCodeTimer);
          this.verCodeTime = 120;
          this.isSendVerCode = false;
        }
      }, 1000);
    },
    handleConfirmZoneCode(e){
      this.form.zone_code = e.value;
      this.showZoneCodePicker = false;
    },
    login(){
      this.form.phone = trimPlus(this.form.phone);
      this.form.code = trimPlus(this.form.code);
      if(!this.form.phone || !this.form.code) return false;
      this.$apis.authV2LoginApi2(this.form).then(res => {
        const { token, user_info } = res;
        this.$localstorage.set("h5RememberPwd", {
          phone: this.form.phone,
          zone_code: this.form.zone_code,
          account: user_info.user_id
        });
        try {
          // sentry监控，增加额外信息
          if (user_info.user_id) {
            this.addInfoToSentry({
              user_id: user_info.user_id
            });
          }
        } catch (err) {

        }
        this.$localstorage.set("h5userInfo", user_info);
        localStorage.setItem("token", token);
        // 登录成功
        this.$apis
          .accountList()
          .then(res => {
            this.$router.replace("/h5-page-account");
          })
          .catch(e => {
            
          });
      });
    },
    // 上报
    addInfoToSentry(infoObj = {}) {
      Sentry.configureScope(scope => {
        scope.setUser(infoObj);
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "./form.comon.less";
.icon-box{
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
